import { RpaLicenseBindingEntityModel } from "src/store/models/entity/rpaLicenseBinding/entity";

export const encooRpaLicenseBindingModels = {
  entity: RpaLicenseBindingEntityModel,
};
